// Определяем, является ли система Mac
const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;

// Создаем объект с шорткатами
const shortcuts = {
    en: {
        openContacts: 'Open Contacts',
        openSearch: 'Open Search',
        clearSearch: 'Clear Search',
        shortcutKey: isMac ? '⌘+K' : 'Ctrl+K',
        clearShortcut: 'Ctrl+C'
    },

};

export const translations = {
    en: {
        // Navigation & Common
        dashboard: 'Dashboard',
        contacts: 'Contacts',
        profile: 'Profile',
        appearance: 'Look and feel',
        language: 'Language',
        english: 'English',
        theme: 'Visual mode',
        light: 'Light',
        dark: 'Dark',
        search: 'Search',
        add: 'Add',
        edit: 'Edit',
        delete: 'Delete',
        cancel: 'Cancel',
        save: 'Save',
        close: 'Close',
        view: 'View',
        explore: 'Explore',
        logout: 'Logout',
        welcome: 'Welcome',
        welcomeMessage: 'Hello,',
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        country: 'Country',
        address: 'Address',
        notes: 'Notes',
        tags: 'Tags',
        addTag: 'Add Tag',
        newTag: 'New Tag',
        today: 'Today',
        tomorrow: 'Tomorrow',
        inDays: 'In {{days}} days',
        location: 'Location',
        total: 'total',
        additionalInfo: 'Additional Info',
        noResults: 'No results found',
        company: 'Company',
        jobTitle: 'Job Title',
        city: 'City',
        website: 'Website',
        firstName: 'First Name',
        lastName: 'Last Name',
        fullName: 'Full Name',
        region: 'Region/State',
        postalCode: 'Postal Code',
        savingChanges: 'Saving changes...',
        profileSaved: 'Profile saved successfully',
        selectCountryFirst: 'Select country first',
        coordinatesNotFound: 'Coordinates not found for this city. The contact may not appear on the map. Try selecting a city from the dropdown list.',
        enterAtLeast3Chars: 'Enter at least 3 characters to search',
        noOptions: 'No options',

        // Dashboard
        contactsOverview: 'Contacts Overview',
        totalContacts: 'Total Contacts',
        activeContacts: 'Active Contacts',
        upcomingEventsCount: 'Upcoming Events',
        dueContactsCount: 'Due Contacts',
        totalTags: 'Total Tags',
        upcomingEvents: 'Upcoming Events',
        dueContacts: 'Due Contacts',
        dueToday: 'Due today',
        dueInDays: 'Due in {{days}} days',
        dueDate: 'Due date',
        overdue: 'Overdue',
        contactDue: 'Contact due',
        noUpcomingEvents: 'No upcoming events in the next 30 days',
        noDueContacts: 'No contacts due in the next 3 days',
        dueSoon: 'Due soon',
        overdueDays: 'Overdue by {{days}} days',

        // Activity
        activityProgress: 'Activity Progress',
        dayStreak: 'Day Streak',
        activeContactsProgress: 'Active Contacts',
        recommendations: 'Recommendations',
        noContactDays: 'No contact for {{days}} days',
        followUpMeeting: 'Follow up on recent meeting',
        viewContact: 'View Contact',

        // Contacts
        contactList: 'Contact List',
        worldMap: 'World Map',
        addContact: 'Add Contact',
        editContact: 'Edit Contact',
        deleteContact: 'Delete Contact',
        confirmDelete: 'Are you sure you want to delete this contact?',
        lastInteraction: 'Last touch',
        interactions: 'Touches',
        touches: 'Touches',
        touchesSubtitle: 'A quiet history of calls, messages, meetings, and moments worth remembering.',
        addInteraction: 'Add touch',
        addTouch: 'Add touch',
        editTouch: 'Edit touch',
        deleteTouch: 'Delete touch',
        confirmDeleteTouch: 'Delete this touch?',
        noInteractions: 'No touches recorded',
        noTouches: 'No touches yet',
        noTouchesSubtitle: 'Add a short note after a call, message, meeting, or thoughtful moment.',
        noTouchNotes: 'No note added',
        contactFrequency: 'Contact Frequency (days)',
        contactEveryDays: 'Contact every {{days}} days',
        noContactFrequency: 'No contact frequency set',
        contactAdded: 'Contact added successfully',
        contactUpdated: 'Contact updated successfully',
        contactDeleted: 'Contact deleted successfully',
        errorAddingContact: 'Error adding contact',
        errorUpdatingContact: 'Error updating contact',
        errorDeletingContact: 'Error deleting contact',
        
        // Relations between contacts
        contactRelations: 'Common Connections',
        connections: 'Common Contacts',
        relations: 'Relationships',
        addRelation: 'Add Contact',
        relationType: 'Connection Type',
        relationTypeHelper: 'Type to search or create new type',
        selectContact: 'Select Contact',
        classmate: 'Classmate',
        colleague: 'Colleague',
        relative: 'Relative',
        partner: 'Partner',
        client: 'Client',
        personalInfo: 'Personal Info',
        newRelationType: 'Type or select connection type',
        availableRelationTypes: 'Available relationship types:',
        relationAdded: 'Contact connection added successfully',
        relationRemoved: 'Contact connection removed successfully',
        noConnections: 'No common contacts yet',
        lastContact: 'Last contact',
        importantDates: 'Important Dates',
        importantDate: 'Important Date',

        // Interactions
        interactionAdded: 'Touch added',
        interactionUpdated: 'Touch updated',
        interactionDeleted: 'Touch deleted',
        touchUpdated: 'Touch updated',
        touchDeleted: 'Touch deleted',
        errorAddingInteraction: 'Error adding touch',
        errorUpdatingInteraction: 'Error updating touch',
        errorDeletingInteraction: 'Error deleting touch',
        
        // Tags
        tagCloud: 'Tag Cloud',
        contactsWithTag: 'Contacts with tag',
        noContactsWithTag: 'No contacts found with this tag',
        noTags: 'No tags found',
        clearFilter: 'Clear filter',

        // Countries
        countries: 'Countries',
        contactsFromCountry: 'Contacts from',
        noContactsFromCountry: 'No contacts from this country',
        noCountries: 'No countries found',

        // Social Media
        socialMedia: 'Social Media',
        otherSocialMedia: 'Other Social Media',
        otherSocialMediaPlaceholder: 'Enter URL (e.g., github.com/username)',

        // Auth & App
        loginWithGoogle: 'Login with Google',
        demoMessage: 'Try it before signing up',
        appName: 'In Touch',
        slogan: 'Building Meaningful Connections, One Touch at a Time',
        notifications: 'Notifications',
        jobTitles: 'Job Titles',
        contactsFromCompany: 'Contacts from',
        contactsWithJobTitle: 'Contacts with title',
        colorScheme: 'Color Scheme',
        colorPreview: 'Color Preview',
        primary: 'Primary',
        secondary: 'Secondary',
        noCompanies: 'No companies found',
        noJobTitles: 'No job titles found',
        noInteractionYet: 'No touches yet',
        needsAttention: 'Needs Attention',
        contactsDue: 'Contacts Due',
        needsFollowUp: 'Needs Follow-up',
        requiresAction: 'Requires Action',
        interactionDate: 'Date & Time',
        required: 'This field is required',
        textInput: 'Text Input',
        voiceRecording: 'Voice Recording',
        startRecording: 'Start Recording',
        stopRecording: 'Stop',
        transcribing: 'Transcribing...',
        transcribe: 'Transcribe',
        voiceRecordingTitle: 'Voice Recording',
        currentNotes: 'Current Notes:',
        transcriptionResult: 'Transcription:',
        recordingHelper: 'Click "Start Recording" to record a voice note. Maximum duration is 3 minutes.',
        recordingStatus: {
            recording: 'Recording',
            paused: 'Paused',
            recorded: 'Recorded'
        },
        errors: {
            microphoneAccess: 'Failed to access microphone. Please check permissions.',
            transcriptionFailed: 'Failed to transcribe audio. Please try again.',
            recordingFailed: 'Failed to start recording'
        },

        shortcuts: shortcuts.en,
        saveInteraction: 'Save touch',
        dateType: 'Event Name',
        date: 'Date',
        addDate: 'Add Date',

        // Connector
        connector: 'Connector',
        connectorDescription: 'This contact can introduce you to new interesting people',
        markAsConnector: 'Mark as Connector',
        
        // Brain
        brain: 'Brain',
        brainDescription: 'This contact accumulates knowledge and experience',
        markAsBrain: 'Mark as Brain',
        
        // Map related
        contactsMap: 'Contacts Map',
        contactsMapDescription: 'View your contacts on a world map by location',
        noContactsWithAddresses: 'No contacts with complete address information found. Add addresses with coordinates to your contacts to see them on the map.',
        noContactsWithCities: 'No contacts with city information found. Add cities to your contacts to see them on the map. Make sure to select both country and city when adding or editing contacts.',
        viewDetails: 'View Details',
        viewAllContacts: 'View All Contacts',
        contactsIn: 'Contacts in',

        // Contact details
        emailAddresses: 'Email Addresses',
        phoneNumbers: 'Phone Numbers',
        addresses: 'Addresses',
        birthday: 'Birthday',


        analytics: 'Analytics',
        summaryStatistics: 'Summary Statistics',
        topCountries: 'Top Countries',
        contactActivityByMonth: 'Contact Activity by Month',
    }
};
